import { render } from "./expertOverviewItemCard.vue?vue&type=template&id=bd549d0a&scoped=true&ts=true"
import script from "./expertOverviewItemCard.vue?vue&type=script&lang=ts"
export * from "./expertOverviewItemCard.vue?vue&type=script&lang=ts"

import "./expertOverviewItemCard.vue?vue&type=style&index=0&id=bd549d0a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd549d0a"]])

export default __exports__